/*
 * @Descripttion: 
 * @version: 
 * @Author: 
 * @Date: 2022-09-14 19:04:08
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-20 15:34:42
 */

export default {
    Home: {
        List: {
            Title: 'Confirmed Merchants',
            Tip: '本界面展示近30天通過FotonCard虛擬卡支付成功的商戶清單，不代表虛擬卡局限于以下支付場景，新上綫的卡BIN數據可能較少。注意：虛擬卡實際支付通過率受多種因素限制（如消费商户KYC、各站點風控政策等），FotonCard不保證所有場景100%支付通過。',
            QuickSearch: '快速搜索',
            MerchantName: '商戶名',
            MerchantNameInputTip: '輸入商戶名關鍵詞，如：NETFLIX / Line',
            PaymentCurrency: '支付幣種',
            Search: '搜索',
            SuccessfulBINS: '成功支付卡BIN',
            SuccessfulCurrency: '成功支付幣種',
            SuccessfullyPaid: '近30天成功支付歸納',
            Bin428837: {
                AmazonUSPayment: '亞馬遜美國站支付',
                AmazonUKPayment: '亞馬遜英國站支付',
                AmazonGERPayment: '亞馬遜德國站支付',
                EBayPayment: 'eBay支付',
                EstyPurchasePayment: 'Etsy買家號下單支付',
                GoolgePlayPayment: '美區Google Play綁卡購買app支付',
                PayAtShopee: 'Shopee下單付款',
                GoogleAdsPayment: 'Google Ads廣告扣費',
                FacebookAdsPayment: 'Facebook廣告投放扣費',
                KindlePayment: 'Kindle支付',
                WalmartPayment: 'Walmart支付',
                PayPalBainding: 'PayPal綁定',
                TaobaoPayment: '淘寶下單付款',
                AliexpressPayment: 'Aliexpress支付'
            },
            Bin222929: {
                AmazonUSPayment: '亞馬遜美國站支付',
                AmazonUKPayment: '亞馬遜英國站支付',
                AmazonGERPayment: '亞馬遜德國站支付',
                EBayPayment: 'eBay支付',
                EstyPurchasePayment: 'Etsy買家號下單支付',
                GoolgePlayPayment: '美區Google Play綁卡購買app支付',
                AlipayHKBindingAndPayAtHKTVmall: '香港支付寶綁定並在HKTVmall海淘',
                WechatBindingAndPayment: '綁定微信支付',
                BestBuyUSAPaymentWithAnyBillingAddress: 'BestBuy美國站下單付款，未被砍單，Billing Address可任意填寫',
                PayAtNIKEWithAnyBillingAddress: 'Nike官網下單付款，Billing Address可任意填寫',
                PayAtAdidasHKSite: 'Adidas HK官網下單付款',
                PayAtFordeal: 'Fordeal電商平台下單付款',
                PayAtShopee: 'Shopee下單付款',
                GoogleAdsPayment: 'Google Ads廣告扣費',
                FacebookAdsPayment: 'Facebook廣告投放扣費',
                TelegramPremiumPayment: 'Telegram綁定及會員購買',
                TaobaoPayment: '淘寶下單付款',
                AliexpressPayment: 'Aliexpress支付',
                PayPalPainding: 'PayPal綁定',
                LazadaPayment: 'Lazada綁定及支付',
                AppleUS: 'APPLE US支付'
            },
            Bin472593: {
                EstyPurchasePayment: 'Etsy買家號下單支付',
                EBayPayment: 'eBay支付',
                GoogleAdsPayment: 'Google Ads廣告扣費',
                FacebookAdsPayment: 'Facebook廣告投放扣費',
                AIRBNBPayment: 'AIRBNB支付',
                AmazonUSPayment: '亞馬遜美國站支付',
                GoolgePlayPayment: '美區Google Play綁卡購買app支付',
                PayPalBainding: 'PayPal綁定',
                ShopeePay: 'Shoppe綁定與支付',
                TelegramPremiumHongKong: 'Telegram會員扣費（香港）'
            },
            Bin556766: {
                AmazonPayment: '亞馬遜支付',
                AliExpressPayment: 'AliExpress支付',
                eBayPayment: 'eBay支付',
                MercariPayment: 'Mercari支付',
                EtsyPayment: 'Etsy支付',
                PoshMarkPayment: 'PoshMark支付',
                AlibabaPayment: 'Alibaba支付',
                WalmartPayment: 'Walmart支付',
                FacebookAdsPayment: 'Facebook Ads支付',
                TikTokAdsPayment: 'TikTok Ads支付',
                GoogleAdsPayment: 'Google Ads支付',
                PinterestAdsPayment: 'Pinterest Ads支付',
                SupremePayment: 'Supreme支付',
                FootLockerPayment: 'Foot Locker支付',
                YezzyPayment: 'Yezzy支付',
                NikePayment: 'Nike支付',
                FootactionPayment: 'Footaction支付',
                GooglePlayPayment: 'Google Play支付',
                AppleStorePayment: 'Apple Store支付',
                NetflixPayment: 'Netflix支付'
            }
        }
    }

}